import {connect} from '@gisatcz/ptr-state';

import Action from "../../state/Action";
import Select from "../../state/Select";

import presentation from './presentation';

const mapStateToProps = (state, ownProps) => {
	return {
		open: Select.components.get(state, 'introOverlay', 'open')
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		changeState: (value) => {
			dispatch(Action.components.set('introOverlay', 'open', value))
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(presentation);
